import "../style/form/investigationform.scss";
import { Investigation, Investigationid } from "../redux/reducer/counterslice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useRef } from "react";
import { InvestigationGet, presignedurl } from "../../text/apidata";
import axios from "axios";
import Button from "@mui/material/Button";
import Swal from "sweetalert2";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import {datetimestring} from "../methods/Methods"
let u1 = [];

export default function InvestigationForm(props) {
  const investigationstate = useSelector(
    (state) => state.counter.Investigation
  );
  const investigationid = useSelector((state) => state.counter.Investigationid);
  const [checked, setchecked] = useState(true);
  const [error, seterror] = useState(false);
  const [visittype, setvisittype] = useState(["home visit", "lab visit"]);
  const [CategoryName, setCategoryName] = useState([
    "Hospital services",
    "Lab investigation services",
  ]);
  const [location, setloaction] = useState([
    { value: "CHETPET", id: "90" },
    { value: "VELACHERY", id: "91" },
    { value: "KOLATHUR", id: "92" },
  ]);
  const [alert, setalert] = useState(false);

  const [subcategoryname, setsubcategoryname] = useState("");
  const [file, setFile] = useState([]);
  const [imgfile, setimgfile] = useState([]);
  const [imgtype, setimgtype] = useState([]);
  const [mapurl, setmapurl] = useState([]);
  const [preurl, setpreurl] = useState([]);
  const [isactive, setisactive] = useState(false);
  console.log(mapurl);

  const [investigationdata, setinvestigationdata] = useState({
    category: "",
    category_name: "",
    sub_category_name: "",
    unit_cost: "0",
    description: "",
    discount: "0",
    investigation_images: [],
    need_prescription: true,
    invest_description: "",
    featured_image: [],
    location_id: "",
    location_name: "",
    visit_type: "",
    featured_product: false,
    is_active: false,
  });

  const [url, setUrl] = useState();
  const [imgfilenew, setimgfilenew] = useState([]);
  const [imgtypenew, setimgtypenew] = useState([]);
  const [preurlnew, setpreurlnew] = useState([]);
  const [checked1, setChecked1] = useState(false);
  const [CroppImageView, setCroppImageView] = useState(false);
  const [CroppImageViewCount, setCroppImageViewCount] = useState(0);
  const [imgsrc, setImgsrc] = useState();
  const imgRef = useRef(null);
  const [crop, setCrop] = useState();

  const dispatch = useDispatch();
  const cancelnewuser = () => {
    if (alert) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, revert it!",
      }).then((result) => {
        if (result.isConfirmed) {
          // Swal.fire(
          //   "Deleted!",
          //   "Given Info has been deleted.",
          //   "success"
          // );
          dispatch(Investigation(""));
          setalert(false);
        }
      });
    } else {
      dispatch(Investigation(""));
      setalert(false);
    }
  };
  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const checkbox = (e) => {
    setalert(true);

    setchecked(!checked);
    const { name, value } = e.target;
    setinvestigationdata({
      ...investigationdata,
      [name]: !checked,
    });
  };
  const checkbox1 = (e) => {
    // console.log(e, e.target.checked);
    setalert(true);

    setChecked1(e.target.checked);
    setinvestigationdata({
      ...investigationdata,
      [e.target.name]: e.target.checked,
    });
  };
  const checkbox2 = (e) => {
    setalert(true);
    setisactive(e.target.checked);
    setinvestigationdata({
      ...investigationdata,
      [e.target.name]: e.target.checked,
    });
  };

  useEffect(() => {
    if (investigationstate == "Edit") {
      props.loaderchange("true");

      axios({
        method: "get",
        url: InvestigationGet + investigationid + "/",
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token") + "",
        },
      })
        .then((res) => {
          console.log(res);
          setUrl(res.data.data.featured_image);
          setsubcategoryname(res.data.data.sub_category_name);
          setisactive(res.data.data.is_active);
          setinvestigationdata({
            ...investigationdata,
            category: res.data.data.category,
            category_name: res.data.data.category_name,
            sub_category_name: res.data.data.sub_category_name,
            unit_cost: res.data.data.unit_cost,
            description: res.data.data.description,
            discount: res.data.data.discount,
            need_prescription: res.data.data.need_prescription,
            invest_description: res.data.data.invest_description,
            visit_type: res.data.data.visit_type,
            investigation_images: res.data.data.investigation_images,
            featured_image: res.data.data.featured_image,
            location_id: res.data.data.location_id,
            location_name: res.data.data.location_name,
            is_active: res.data.data.is_active,
            featured_product: res.data.data.featured_product,
          });
          setFile(
            res.data.data.investigation_images != null
              ? res.data.data.investigation_images
              : ""
          );

          res.data.data.investigation_images != null &&
            res.data.data.investigation_images.length > 0 &&
            res.data.data.investigation_images.map((ele) => {
              u1.push(ele);
            });
          setChecked1(res.data.data.featured_product);

          setchecked(res.data.data.need_prescription);
          props.loaderchange("false");
        })
        .catch((error) => {
          console.log(error);
          props.loaderchange("false");
        });
    }
  }, [investigationid]);

  const validation = (e) => {
    setalert(true);

    console.log(e);
    const { name, value } = e.target;
    setinvestigationdata({
      ...investigationdata,
      [name]: value,
    });
    if (name == "unit_cost") {
      if (e.target.value <= 0) {
        setinvestigationdata({
          ...investigationdata,
          [name]: value,
        });
      } else {
        setinvestigationdata({
          ...investigationdata,
          [name]: 0,
        });
      }
    }
    if (name == "discount") {
      if (e.target.value != "") {
        if (e.target.value > 100) {
          // alert("No numbers above 100");
          setinvestigationdata({
            ...investigationdata,
            [name]: 100,
          });
        } else {
          setinvestigationdata({
            ...investigationdata,
            [name]: value,
          });
        }
      } else {
        setinvestigationdata({
          ...investigationdata,
          [name]: 0,
        });
      }
    }

    if (name == "category_name") {
      if (value == "Hospital services") {
        setinvestigationdata({
          ...investigationdata,
          sub_category_name: "MASTER HEALTH CHECK",
          [name]: value,
        });
      } else {
        setinvestigationdata({
          ...investigationdata,
          sub_category_name: subcategoryname,
          [name]: value,
        });
      }
    }
    if (name == "location_name") {
      console.log(e.target.options[e.target.selectedIndex].attributes[1].value);
      setinvestigationdata({
        ...investigationdata,
        [name]: value,
        location_id:
          e.target.options[e.target.selectedIndex].attributes[1].value,
      });
    }
  };

  const newusercreate = () => {
    console.log(investigationdata);
    if (
      investigationdata.category != "" &&
      investigationdata.category_name != "" &&
      investigationdata.sub_category_name != "" &&
      investigationdata.unit_cost != "" &&
      investigationdata.description != "" &&
      investigationdata.invest_description != "" &&
      investigationdata.investigation_images != "" &&
      investigationdata.location_name != ""
    ) {
      if (investigationstate == "Edit") {
        props.loaderchange("true");
        mapurl.forEach((ele) => {
          async function editimage() {
            const resp = await fetch(ele.url, {
              method: "PUT",
              body: ele.file,
              headers: {
                "Content-Type": ele.type,
                "X-Amz-ACL": "public-read",
              },
            })
              .then((res) => {
                console.log(res);
              })

              .catch((err) => {
                console.log(err);
                props.loaderchange("false");
                return null;
              });
          }
          editimage();
        });
        async function editimage1() {
          if (preurlnew && preurlnew.length > 0) {
            console.log(preurlnew, imgtypenew, imgfilenew);
            const resp = await fetch(preurlnew, {
              method: "PUT",
              body: imgfilenew,
              headers: {
                // "Authorization": "Bearer " + localStorage.getItem("token") + "",
                "Content-Type": imgtypenew,
                "X-Amz-ACL": "public-read",
              },
            }).catch((err) => {
              console.log(err);
              return null;
            });
          }
        }

        editimage1();
        setTimeout(() => {
          axios({
            method: "put",
            url: InvestigationGet + investigationid + "/",
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token") + "",
            },
            data: investigationdata,
          })
            .then((res) => {
              setalert(false);

              console.log(res);
              dispatch(Investigation(""));
              setFile([]);
              setimgfile([]);
              setimgtype([]);
              setmapurl([]);
              setpreurl([]);
              u1 = [];
              setinvestigationdata({
                ...investigationdata,
                investigation_images: [],
              });
              props.popupalert("true");
              props.popuptext("Investigations updated Successfully");

              setTimeout(() => {
                props.popupalert("false");
              }, 2000);

              props.loaderchange("false");
            })
            .catch((error) => {
              console.log(error);
            });
        }, 500);
      } else {
        if (preurl && preurl.length > 0) {
          props.loaderchange("true");

          mapurl.forEach((ele) => {
            async function uploadimage() {
              const resp = await fetch(ele.url, {
                method: "PUT",
                body: ele.file,
                headers: {
                  // "Authorization": "Bearer " + localStorage.getItem("token") + "",
                  "Content-Type": ele.type,
                  "X-Amz-ACL": "public-read",
                },
              })
                .then((res) => {
                  console.log(res);

                  // props.loaderchange("false");
                })

                .catch((err) => {
                  console.log(err);
                  // props.loaderchange("false");
                  return null;
                });
            }
            uploadimage();
          });
          async function uploadimage1() {
            if (preurlnew && preurlnew.length > 0) {
              const resp1 = await fetch(preurlnew, {
                method: "PUT",
                body: imgfilenew,
                headers: {
                  // "Authorization": "Bearer " + localStorage.getItem("token") + "",
                  "Content-Type": imgtypenew,
                  "X-Amz-ACL": "public-read",
                },
              }).catch((err) => {
                console.log(err);
                return null;
              });
            }
          }
          uploadimage1();
          setTimeout(() => {
            // props.loaderchange("true");
            axios({
              method: "post",
              url: InvestigationGet,
              headers: {
                Authorization: "Bearer " + localStorage.getItem("token") + "",
              },
              data: investigationdata,
            })
              .then((res) => {
                console.log(res);
                setFile([]);
                setimgfile([]);
                setimgtype([]);
                setmapurl([]);
                setpreurl([]);
                u1 = [];
                setalert(false);

                setinvestigationdata({
                  ...investigationdata,
                  investigation_images: [],
                });

                dispatch(Investigation(""));
                props.popupalert("true");
                props.popuptext("Investigations Created Successfully");

                setTimeout(() => {
                  props.popupalert("false");
                }, 2000);

                props.loaderchange("false");
              })
              .catch((error) => {
                console.log(error);
              });
          }, 500);
        }
      }
    } else {
      seterror(true);
      if (
        investigationdata.investigation_images == "" ||
        investigationdata.featured_image == ""
      ) {
        props.popupalert("true");
        props.popuptext("Upload Investigation Images ");

        setTimeout(() => {
          props.popupalert("false");
        }, 2000);
      }
    }
  };

  ///img
  const uploadSingleFile = (e) => {
    if (e.target.files.length == 1) {
      selectedImage(e);
      setalert(true);

      setCroppImageViewCount(2);
      setCroppImageView(true);
    } else if (e.target.files[0]) {
      setalert(true);

      console.log(e.target.files);
      var url;
      if (e.target.files.length > 0) {
        const filesArray = Array.from(e.target.files); // Convert FileList to array
        filesArray.forEach((ele) => {
          setFile((oldArray) => [
            ...oldArray,
            String(URL.createObjectURL(ele)),
          ]);

          setimgfile((oldArray) => [...oldArray, ele]);
          setimgtype((oldArray) => [...oldArray, ele.type]);
          // Do something with the 'url' object, if needed.
        });

        let filename_new = datetimestring()
        var val = String(Math.floor(Math.random() * 10**4)) + filename_new;
        url = {
          multiple_files: filesArray.map((file) => ({
            ["filename"]:
              "assestsfortesting" +
              "/" +
              String(val) +
              String(file.name).replace(/ +/g, ""),
            ["file_type"]: file.type,
          })),
        };

        setTimeout(() => {
          console.log(url);
        }, 1000);
        axios({
          method: "post",
          url: presignedurl,
          data: url,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token") + "",
          },
        })
          .then((res) => {
            console.log(res);
            res.data.data.map((data, index) => {
              setpreurl((oldArray) => [...oldArray, data]);
              u1.push(data.split("?")[0]);
              setmapurl((oldArray) => [
                ...oldArray,
                {
                  url: data,
                  type: url.multiple_files[index]["file_type"],
                  file: filesArray[index],
                },
              ]);
            });

            console.log(mapurl);
            setinvestigationdata({
              ...investigationdata,
              investigation_images: u1,
            });
          })
          .catch((error) => {
            console.log(error);
          });
      }
    }
  };
  const deleteFile = (e) => {
    setalert(true);

    const s = file.filter((item, index) => index !== e);
    const t = imgfile.filter((item, index) => index !== e);
    const u = preurl.filter((item, index) => index !== e);
    const v = mapurl.filter((item, index) => index !== e);
    const w = u1.filter((item, index) => index !== e);
    const i = imgtype.filter((item, index) => index !== e);

    setimgtype(i);
    setimgfile(t);
    setpreurl(u);
    setFile(s);
    setmapurl(v);
    console.log(w);
    u1 = [];

    u1 = w;
    console.log(u1);
    setinvestigationdata({
      ...investigationdata,
      investigation_images: u1,
    });
  };

  ///
  const handleFiles = (e) => {
    selectedImage(e);
    setCroppImageViewCount(1);
    setCroppImageView(true);
    setalert(true);
  };
  const cancel = (e) => {
    setalert(true);

    setUrl("");
    setinvestigationdata({
      ...investigationdata,
      featured_image: "",
    });
  };

  const onImageLoaded = (image) => {
    // imgRef = image;
    imgRef.current = image;
  };
  function getCroppedImg(a, crop, fileName) {
    const canvas = document.createElement("canvas");
      const image = document.getElementById("localimg");
      const scaleX = image.naturalWidth / image.width;
      const scaleY = image.naturalHeight / image.height;
      if(crop){
        canvas.width = crop.width;
      canvas.height = crop.height;
      }
      else{
        canvas.width = image.width;
      canvas.height = image.height;
      }
      const ctx = canvas.getContext("2d");
  if(crop){
    ctx.drawImage(
      image,
      crop.x * scaleX,
      crop.y * scaleY,
      crop.width * scaleX,
      crop.height * scaleY,
      0,
      0,
      crop.width,
      crop.height
    );
  
  }
  else{
    ctx.drawImage(
      image,
      scaleX,
      scaleY,
      image.width* scaleX,
      image.height* scaleY,
      0,
      0,
      image.width,
      image.height,
    );
  
  }
      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (!blob) {
            //reject(new Error('Canvas is empty'));
            console.error("Canvas is empty");
            return;
          }
          
          const croppedFile = new File([blob], "croppedimg.jpg", {
            type: "image/jpeg",
          });
          if (CroppImageViewCount == 1) {
            setalert(true);

            console.log(croppedFile);
            setimgfilenew(croppedFile);
            setimgtypenew(croppedFile.type);
            var file = croppedFile;
            var reader = new FileReader();
            reader.onloadend = function () {
              setUrl(reader.result);
            };
            reader.readAsDataURL(file);
            let filename_new = datetimestring()
            var val = String(Math.floor(Math.random() * 10**4)) + filename_new;
            var url1 = {
              multiple_files: [
                {
                  ["filename"]:
                    "assestsfortesting" +
                    "/" +
                    String(val) +
                    String(croppedFile.name).replace(/ +/g, ""),
                  // ["file_type"]: e.target.files[0].type,
                  ["file_type"]: croppedFile.type,
                },
              ],
            };

            setTimeout(() => {
              axios({
                method: "post",
                url: presignedurl,
                data: url1,
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token") + "",
                },
              })
                .then((res) => {
                  setpreurlnew(String(res.data.data));

                  setinvestigationdata({
                    ...investigationdata,
                    featured_image: String(res.data.data).split("?")[0],
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
            }, 500);
          } else if (CroppImageViewCount == 2) {
            setalert(true);

            const filesArray1 = croppedFile; // Convert FileList to array
            setFile((oldArray) => [
              ...oldArray,
              String(URL.createObjectURL(croppedFile)),
            ]);

            setimgfile((oldArray) => [...oldArray, croppedFile]);
            setimgtype((oldArray) => [...oldArray, croppedFile.type]);
            var file = croppedFile;
            var reader = new FileReader();
            reader.readAsDataURL(file);

            let filename_new = datetimestring()
            var val = String(Math.floor(Math.random() * 10**4)) + filename_new;
            var url = {
              multiple_files: [
                {
                  ["filename"]:
                    "assestsfortesting" +
                    "/" +
                    String(val) +
                    String(croppedFile.name).replace(/ +/g, ""),
                  // ["file_type"]: e.target.files[0].type,
                  ["file_type"]: croppedFile.type,
                },
              ],
            };

            setTimeout(() => {
              axios({
                method: "post",
                url: presignedurl,
                data: url,
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("token") + "",
                },
              })
                .then((res) => {
                  console.log(res);
                  res.data.data.map((data, index) => {
                    setpreurl((oldArray) => [...oldArray, data]);
                    u1.push(data.split("?")[0]);
                    setmapurl((oldArray) => [
                      ...oldArray,
                      {
                        url: data,
                        type: url.multiple_files[index]["file_type"],
                        file: filesArray1,
                      },
                    ]);
                  });

                  setinvestigationdata({
                    ...investigationdata,
                    investigation_images: u1,
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
            }, 500);
          }
          blob.name = fileName;
          setCroppImageView(false);
          let fileUrl = window.URL.createObjectURL(blob);
          console.log(fileUrl);
          resolve(fileUrl);
        }, "image/jpeg");
      });
    
  }
  const setCompletedCrop = async (c) => {
    const url = await getCroppedImg(imgRef.current, c, "newfile.jpeg");
  };
  const selectedImage = (e) => {
    console.log(e.target.files[0]);
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImgsrc(reader.result));
      reader.readAsDataURL(e.target.files[0]);
    }
  };
  return (
    <>
      <div className="maincontainer_productform">
        <div className="parent-productform">
          <div className="create-productform card">
            <div class="modal-header">
              <h5 class="modal-title">
                {investigationstate == "Edit"
                  ? "Investigation Edit"
                  : "Investigation Create"}
              </h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={(e) => cancelnewuser(e)}
              >
                <i class="bi bi-x-lg"></i>
              </button>
            </div>

            <div class="modal-body" style={{ padding: "0 !important" }}>
              <form
                style={{ padding: "0 1.5rem 0rem" }}
                className="formspace"
                onSubmit={handleSubmit}
              >
                <div class="form-row">
                  <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Category
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom01"
                      name="category"
                      autoComplete="off"
                      value={investigationdata.category}
                      onChange={(e) => validation(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                    ></input>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && investigationdata.category == ""
                        ? "Catagory Required"
                        : ""}{" "}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Unit Cost
                    </label>

                    <div style={{ display: "flex" }}>
                      <span
                        class="input-group-text"
                        id="inputGroupPrepend"
                        style={{ borderRadius: "6px 0px 0px 6px" }}
                      >
                        ₹
                      </span>
                      <input
                        type="number"
                        class="form-control"
                        id="validationCustomn"
                        name="unit_cost"
                        autoComplete="off"
                        style={{ borderRadius: " 0px 6px 6px 0px" }}
                        value={investigationdata.unit_cost}
                        onChange={(e) => validation(e)}
                        onKeyDown={(e)=>{
                          if(!((e.keyCode > 95 && e.keyCode < 106)
      || (e.keyCode > 47 && e.keyCode < 58) 
      || e.keyCode == 8)) {
        e.preventDefault()
    }
                        }}

                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                      ></input>
                    </div>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && investigationdata.unit_cost == ""
                        ? "Unit Cost Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom01" class="form-label">
                      Discount
                    </label>
                    <div style={{ display: "flex" }}>
                      <span
                        class="input-group-text"
                        id="inputGroupPrepend"
                        style={{ borderRadius: "6px 0px 0px 6px" }}
                      >
                        %
                      </span>

                      <input
                        type="number"
                        class="form-control"
                        id="validationCustomn1"
                        name="discount"
                        autoComplete="off"
                        onKeyDown={(e)=>{
                          if(!((e.keyCode > 95 && e.keyCode < 106)
      || (e.keyCode > 47 && e.keyCode < 58) 
      || e.keyCode == 8)) {
        e.preventDefault()
    }
                        }}

                        style={{ borderRadius: " 0px 6px 6px 0px" }}
                        value={investigationdata.discount}
                        onChange={(e) => validation(e)}
                        max="100"
                        required
                        onWheel={(e) => {
                          document.activeElement.blur();
                        }}
                      ></input>
                    </div>
                    {/* <p style={{ fontSize: "12px", color: "red" }}>
                      {error && investigationdata.discount == ""
                        ? "Discount Required"
                        : ""}
                    </p> */}
                  </div>
                </div>
                <div className="form-row">
                  <div class="form-group col-md-6 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Category Name
                    </label>
                    {/* <input
                      type="text"
                      class="form-control"
                      id="validationCustom03"
                      name="category_name"
                      autoComplete="off"
                      value={investigationdata.category_name}
                      onChange={(e) => validation(e)}
                    ></input> */}
                    <select
                      className="form-select"
                      value={investigationdata.category_name}
                      name="category_name"
                      onChange={(e) => validation(e)}
                    >
                      <option selected disabled value="">
                        ....Please Select
                      </option>
                      {CategoryName.map((ele) => {
                        return <option value={ele}>{ele}</option>;
                      })}
                    </select>

                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && investigationdata.category_name == ""
                        ? "Category Name  Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-6 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Sub Category Name
                    </label>
                    <input
                      type="text"
                      class="form-control"
                      id="validationCustom03"
                      name="sub_category_name"
                      autoComplete="off"
                      value={investigationdata.sub_category_name}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      readonly={
                        investigationdata.category_name == "MASTER HEALTH CHECK"
                      }
                      onChange={(e) => validation(e)}
                    ></input>

                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && investigationdata.sub_category_name == ""
                        ? "Sub Category Name  Required"
                        : ""}
                    </p>
                  </div>
                </div>
                <div className="form-row">
                  <div class="form-group col-md-6 p-1 m-0">
                    <label class="form-label">Location Name</label>

                    <select
                      className="form-select"
                      value={investigationdata.location_name}
                      onChange={(e) => validation(e)}
                      name="location_name"
                    >
                      <option selected disabled value="">
                        ...Please Select
                      </option>
                      {location.map((data) => {
                        return (
                          <option value={data.value} data={data.id}>
                            {data.value}
                          </option>
                        );
                      })}
                    </select>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && investigationdata.location_name == ""
                        ? "Location Name  Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-6 p-1 m-0">
                    <label class="form-label">Location Id</label>
                    <input
                      class="form-control"
                      name="location_id"
                      value={investigationdata.location_id}
                      readOnly
                    ></input>
                  </div>
                </div>
                <div className="form-row">
                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Invest Description
                    </label>
                    <textarea
                      type="textarea"
                      class="form-control"
                      id="validationCustom01"
                      name="invest_description"
                      style={{ resize: "none" }}
                      value={investigationdata.invest_description}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      onChange={(e) => validation(e)}
                      rows="3"
                    ></textarea>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && investigationdata.invest_description == ""
                        ? "Invest Description  Required"
                        : ""}
                    </p>
                  </div>
                  <div class="form-group col-md-4 p-1 m-0">
                    <label for="validationCustom04" class="form-label">
                      Description
                    </label>
                    <textarea
                      type="textarea"
                      class="form-control"
                      id="validationCustom01"
                      name="description"
                      value={investigationdata.description}
                      style={{ resize: "none" }}
                      onChange={(e) => validation(e)}
                      onKeyDown={(e) => {
                        if (e.target.value.length === 0 && e.which === 32) {
                          e.preventDefault();
                        }
                      }}
                      rows="3"
                    ></textarea>

                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && investigationdata.description == ""
                        ? "Description  Required"
                        : ""}
                    </p>
                  </div>
                  <div
                    class="form-group col-md-4 p-2 m-0"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <input
                      class="form-check-input"
                      type="checkbox"
                      name="need_prescription"
                      checked={checked}
                      onChange={(e) => checkbox(e)}
                      style={{ margin: "auto" }}
                      id="invalidCheck"
                    ></input>
                    <label
                      class="form-check-label"
                      for="invalidCheck"
                      style={{ margin: "24px" }}
                    >
                      Need Prescription
                    </label>
                  </div>

                  <div class="form-group col-md-4 p-2 m-0">
                    <label for="validationCustom04" class="form-label">
                      Visit Type
                    </label>
                    <select
                      class="form-select"
                      id="validationCustom04"
                      value={investigationdata.visit_type}
                      name="visit_type"
                      onChange={(e) => validation(e)}
                    >
                      <option selected disabled value="">
                        Choose...
                      </option>
                      {visittype.map((data) => {
                        return <option value={data}>{data}</option>;
                      })}
                    </select>
                    <p style={{ fontSize: "12px", color: "red" }}>
                      {error && investigationdata.visit_type == ""
                        ? "Status Required"
                        : ""}
                    </p>
                  </div>
                  <div
                    class="col-md-2 mr-5"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        checked={checked1}
                        name="featured_product"
                        onChange={(e) => checkbox1(e)}
                        id="invalidCheck"
                      ></input>
                      <label class="form-check-label" for="invalidCheck">
                        Featured Investigation
                      </label>
                    </div>
                  </div>
                  <div
                    class="col-md-2"
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        name="is_active"
                        checked={isactive}
                        onChange={(e) => checkbox2(e)}
                        id="invalidCheck"
                      ></input>
                      <label class="form-check-label" for="invalidCheck">
                        Is Active
                      </label>
                    </div>
                  </div>
                </div>
                <div
                  class="form-row"
                  style={{
                    display: "flex",
                    flexFlow: "row wrap",
                    placeContent: "center space-between",
                    alignItems: "center",
                  }}
                >
                  <div class="col-md-6 p-1 m-0">
                    <div className="form-group preview">
                      <div className="imgouters" style={{ display: "flex" }}>
                        {file &&
                          file.length > 0 &&
                          file.map((item, index) => {
                            return (
                              <>
                                <img
                                  onClick={(e) => {
                                    window.open(item);
                                  }}
                                  className="pointer"
                                  style={{
                                    height: "2.5rem",
                                    width: "2.5rem",
                                    borderRadius: "50%",
                                    margin: "10px 10px 10px 20px",
                                  }}
                                  src={item}
                                  alt=""
                                />
                                <button
                                  type="button"
                                  style={{
                                    position: "relative",
                                    height: "20px",
                                    width: "20px",
                                    margin: "-10px",
                                    borderRadius: "50%",
                                    backgroundColor: "#1b5a90",
                                  }}
                                  onClick={() => deleteFile(index)}
                                >
                                  <i
                                    class="bi bi-x"
                                    style={{
                                      margin: "inherit",
                                      color: "white",
                                      position: "relative",
                                      bottom: "2px",
                                    }}
                                  ></i>
                                </button>
                              </>
                            );
                          })}
                      </div>
                    </div>

                    <div className="form-group"></div>
                    <Button
                      className="pharmacyupload"
                      variant="contained"
                      component="label"
                      disabled={file && file.length > 5}
                    >
                      {" "}
                      <input
                        type="file"
                        disabled={file && file.length > 5}
                        hidden
                        className="form-control"
                        accept="image/png, image/jpeg"
                        onChange={uploadSingleFile}
                        multiple
                      />
                      Upload Investigation Images
                    </Button>
                  </div>
                  <div
                    className="col-md-6 p-1 m-0"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <>
                      {url ? (
                        <img
                          onClick={(e) => {
                            window.open(url);
                          }}
                          className="pointer"
                          src={url}
                          style={{
                            height: 115,
                            width: 115,
                            marginRight: 25,
                            borderRadius: "50%",
                          }}
                          alt="Image"
                        />
                      ) : (
                        <p style={{ margin: 0, padding: 10 }}>
                          Upload Featured Picture
                        </p>
                      )}

                      {!url ? (
                        <Button
                          className="doctorupload"
                          variant="contained"
                          component="label"
                        >
                          <p>
                            Upload Image
                            <input
                              type="file"
                              hidden
                              accept="image/png, image/jpeg"
                              onChange={(e) => handleFiles(e)}
                            />
                          </p>
                        </Button>
                      ) : (
                        <></>
                      )}

                      {url ? (
                        <Button
                          className="remove"
                          variant="contained"
                          onClick={(e) => cancel(e)}
                        >
                          {" "}
                          <p>Remove Image</p>
                        </Button>
                      ) : (
                        ""
                      )}
                    </>
                  </div>
                </div>
                <div
                  class="form-row"
                  style={{
                    display: "flex",
                    flexFlow: "row wrap",
                    placeContent: "center space-between",
                    alignItems: "center",
                  }}
                >
                  <div class="form-group col-md-12 pb-3 pt-4 m-0">
                    <button
                      type="submit"
                      class="btn btn-primary  create"
                      onClick={(e) => newusercreate(e)}
                      disabled={
                        investigationstate == "Edit" && !alert ? true : false
                      }
                    >
                      {investigationstate == "Edit"
                        ? "Update Investigation"
                        : "Create Investigation"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {CroppImageView && (
        <div className="Cropper_Wrapper">
          <div className="Cropper_Inner_Wrapper">
            <ReactCrop
              src={imgsrc}
              crop={crop}
              ruleOfThirds
              onImageLoaded={onImageLoaded}
              onChange={(c) => {
                setCrop(c);
                console.log(c);
              }}
              // onComplete={(c) => setCompletedCrop(c)}
            >
              <img src={imgsrc} ref={imgRef} id="localimg" />
            </ReactCrop>
          </div>
          <div className="CropperFooter">
            <button onClick={(e) => setCroppImageView(false)}>Cancel</button>
            <button onClick={(e) => setCompletedCrop(crop)}>Save</button>
          </div>
        </div>
      )}
    </>
  );
}
